import {
  Button,
  Card,
  IconButton,
  Stack,
} from '@mui/material';
import React from 'react';
import GridListGenerator from './GridListGenerator';
import DeleteItemButton from './DeleteItemButton';
import useCreateComplexField from 'Global/Hooks/useCreateComplexField';
import SingleReactHookFormWrapper from 'Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper';
import useCheckEmptyRadioButtonForUiList from 'Global/Components/Generators/FormElementCreatorByType/Hooks/useCheckEmptyRadioButtonForUiList';
import { Edit } from '@mui/icons-material';

const GridUiList = ({
  UiData,
  GridList,
  setGridList,
  index,
  onChange,
  setUiListIndex,
}) => {
  const [RadioValue, setRadioValue] = React.useState();
  const { RadioCount } = useCheckEmptyRadioButtonForUiList(
    GridList,
    index
  );
  const { fields, control, formState, watch, getValues } =
    useCreateComplexField(`UiListDefaultValues`, UiData);

  const fieldlist = watch();
  React.useEffect(() => {
    const newArray = [...GridList];
    newArray[index] = fieldlist?.UiListDefaultValues;

    onChange(newArray);
  }, [fieldlist, GridList]);

  return (
    <React.Fragment>
      <div
        style={{
          padding: '1em',
          border: '1px solid gainsboro',
        }}
      >
        <Stack direction="row-reverse" alignItems="center">
          <DeleteItemButton
            GridList={GridList}
            setGridList={setGridList}
            index={index}
            onChange={onChange}
          />
          <IconButton
            sx={{ p: 0, mb: '.5em', ml: '.5em' }}
            onClick={() => {
              const values = getValues();
              const newArray = [...GridList];
              newArray[index] = values?.UiListDefaultValues;

              setUiListIndex([
                ...newArray[index],
                { index },
              ]);
            }}
          >
            <Edit color="colorPrimer" />
          </IconButton>
        </Stack>

        <Stack spacing={1}>
          {fields?.map((UiItem, i) =>
            UiItem?.element?.ElsRecord?.Type ===
              'RadioButton' ||
            UiItem?.value?.toString()?.length > 0 ? (
              <SingleReactHookFormWrapper
                key={UiItem.id}
                element={
                  <GridListGenerator
                    UiItem={UiItem}
                    RadioValue={RadioValue}
                    setRadioValue={setRadioValue}
                    RadioCount={RadioCount}
                  />
                }
                control={control}
                errors={formState.errors}
                name={`UiListDefaultValues[${i}].value`}
              />
            ) : (
              <React.Fragment
                key={UiItem.id}
              ></React.Fragment>
            )
          )}
        </Stack>
      </div>
    </React.Fragment>
  );
};

export default GridUiList;
